import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "components/AuthLogin/AuthContext";
import BlogEditor from "./BlogEditor";
import FailModal from "./BlogModal/FailModal";

const BlogWrite: React.FC = () => {
    const navigate = useNavigate();
    const { getCookie } = useAuth();
    const [isFailModalOpen, setIsFailModalOpen] = useState(false);

    const handleSubmit = async (formData: FormData) => {
        const apiToken = getCookie('apiToken');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`, {
                method: "POST",
                headers: { 'Authorization': `Bearer ${apiToken}` },
                body: formData,
            });

            if (!response.ok) throw new Error("Network response was not ok");

            const responseData = await response.json();
            navigate(`/blog-single/${responseData.contents.id}`);
        } catch (error) {
            console.error("Error:", error);
            setIsFailModalOpen(true);
        }
    };

    return (
        <>
            <BlogEditor onSubmit={handleSubmit} submitButtonText="Publish" />
            <FailModal
                isOpen={isFailModalOpen}
                onClose={() => setIsFailModalOpen(false)}
                title="Something went wrong"
                mainMessage="Couldn't publish your post."
                subMessage="Please try again."
            />
        </>
    );
};

export default BlogWrite;
